/**
 * Az elem közeléből eltávolítja a hibaüzeneteket
 *
 * @param {HTMLElement | string} targetElement
 */
export function hideErrorMessage(targetElement : JQuery) : void {
    targetElement.removeClass('is-invalid');

    const formControlWrapper = targetElement.closest('.form-control-wrapper');
    formControlWrapper.find('.error, .invalid-feedback').remove();

    const inputWrapper = targetElement.closest('.input-wrapper');
    inputWrapper.find('.error, .invalid-feedback').remove();
}
